import styled from 'styled-components';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    height: 100vh;
    width: 100%;
    justify-content: center;
    align-items: center;
    background-color: ${p => p.bgColor ? p.bgColor : 'transparent'};
    @media screen and (max-width: 1024px) {
        height: auto;
        padding: ${p => p.header ? '50px 0 100px' : '100px 0'};
    }
    @media (max-width: 859px) {
        margin-top: ${p => p.header ? '50px' : '0'};
    }
    @media (max-width: 600px) {
        height: auto;
        padding: 50px 0;
    }
`;

export const Container = styled(GridContainer)`
    justify-content: space-between;
    position: relative;
`;

export const Image = styled.img`
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: auto;
    right: 0;
    margin: auto;
    width: 800px;
    z-index: 0;
    @media (max-width: 1599px) {
        width: 530px;
    }
    @media (max-width: 1279px) {
        width: 400px;
    }
    @media (max-width: 1024px) {
        width: 278px;
    }
    @media (max-width: 920px) and (min-width: 860px) {
        width: 236px;
    }
    @media (max-width: 859px) {
        width: 263px;
    }
    @media (max-width: 730px) {
        width: 100%;
        max-width: 530px;
        position: relative;
        margin: 30px auto;
    }
`;
